import { NotificationCentreListSection } from '../../types'

export const getFlatNotificationList = (
    sections: NotificationCentreListSection[],
) => {
    return sections
        .flatMap((section) => section.notifications)
        .map((notification) => notification.body)
}
